var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBlendMode = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.315 18.588C17.27 17.725 18 16.306 18 14c0-.664-.305-1.64-.997-2.88-.668-1.199-1.585-2.448-2.543-3.604a45.158 45.158 0 0 0-2.484-2.744A40.487 40.487 0 0 0 9.53 7.413C8.577 8.545 7.665 9.778 7 10.982 6.32 12.217 6 13.242 6 14c0 2.306.731 3.725 1.685 4.588C8.672 19.48 10.146 20 12 20c1.854 0 3.328-.519 4.315-1.412ZM12 22c4.418 0 8-2.477 8-8 0-4.693-8-12-8-12S4 9 4 14c0 5.523 3.582 8 8 8Z",
  fill: "currentColor"
})));
export default SvgBlendMode;